/*======================================================================================================================
  * Bluebell: src/app/guards/oauth-token-guard/oauth-token.guard.ts
  * Last Edited: 09/05/2024
  * Copyright 2024 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { selectAccessToken } from '@state/authentication/authentication.selectors';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';


/**
 * Require there to be an oauth access token in the Store or log the user out.
 */
export const oauthTokenGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  return store.select<string|null>(selectAccessToken).pipe(
    map(token => token ? true : router.parseUrl('/logout'))
  );
};
